import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import SignIn from "../../pages/Common/Auth/SignIn";
import SignUp from "../../pages/Common/Auth/SignUp";
import ForgotPassword from "../../pages/Common/Auth/ForgotPassword";
import Verification from "../../pages/Common/Auth/Verification";
import ResetPassword from "../../pages/Common/Auth/ResetPassword";
import { useSelector } from "react-redux";

const AuthRoutes = () => {
  const userAuthenticated = useSelector(state => state?.auth?.isLoggedIn);
  const { logoutByExpertAction } = useSelector(state => state?.auth)
  const [expertAction, setExpertAction] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location?.pathname) {
      setExpertAction(logoutByExpertAction)
    }
  }, [logoutByExpertAction])

  return (
    <div>
      {!userAuthenticated ? (
        <Routes>
          <>
            <Route path="/login" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/auth/apple-login/callback" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-otp" element={<Verification />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {
              expertAction ?
                <Route path="*" element={<Navigate to="/signup" />} />
                :
                <Route path="*" element={<Navigate to="/login" />} />
            }
          </>
        </Routes>
      ) : (
        <AppRoutes />
      )}
    </div>
  )
}

export default AuthRoutes
